<div class="" style="padding: 0 60px;">
    <h6 class="mt-3" style="color:#126db3;margin-left:-15px">{{"action_plan.summary.title" | translate}}</h6>

    <div class="row bg-white mt-2 p-4">
        <div class="col-12 col-lg-4">
            <div class="col-12">
                <h6 class="mt-3" style="color:#126db3;margin-left:-15px">
                    {{"action_plan.summary.materials" | translate}}
                </h6>
            </div>
            <div class="col-12 form-grey p-4" style="height: 300px;overflow-y: auto;overflow-x: hidden;font-size:14px;">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-4 col-md-2">
                                <span>{{"action_plan.summary.tarea" | translate}}</span>
                            </div>
                            <div class="col-8 col-md-10 align">
                                <span>{{"action_plan.summary.materiales" | translate}}</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngFor="let row of materiales;index as i">
                            <div class="row hover" *ngIf="row.recursos">
                                <div class="col-4 col-md-2">
                                    <span class="ml-1">{{i+1}}</span>
                                </div>
                                <div class="col-8 col-md-10 align">
                                    <span class="ml-1">{{row.recursos}}</span>
                                </div>
                            </div>
                            <ng-container *ngIf="row.accion_hijo.length">
                                <ng-container *ngFor="let row1 of row.accion_hijo;index as j">
                                    <div class="row hover" *ngIf="row1.recursos">
                                        <div class="col-4 col-md-2">
                                            <span class="ml-1">{{i+1}}.{{j+1}}</span>
                                        </div>
                                        <div class="col-8 col-md-10 align">
                                            <span class="ml-1">{{row1.recursos}}</span>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="row1.accion_hijo.length">
                                        <ng-container *ngFor="let row2 of row1.accion_hijo;index as k">
                                            <div class="row hover" *ngIf="row2.recursos">
                                                <div class="col-4 col-md-2">
                                                    <span class="ml-1">{{i+1}}.{{j+1}}.{{k+1}}</span>
                                                </div>
                                                <div class="col-8 col-md-10 align">
                                                    <span class="ml-1">{{row2.recursos}}</span>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="row2.accion_hijo.length">
                                                <ng-container *ngFor="let row3 of row.accion_hijo;index as l">
                                                    <div class="row hover" *ngIf="row3.recursos">
                                                        <div class="col-4 col-md-2">
                                                            <span class="ml-1">{{i+1}}.{{j+1}}.{{k+1}}.{{l+1}}</span>
                                                        </div>
                                                        <div class="col-8 col-md-10 align">
                                                            <span class="ml-1">{{row3.recursos}}</span>
                                                        </div>
                                                    </div>
                                                    <ng-container *ngIf="row3.accion_hijo.length">

                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="col-12">
                <h6 class="mt-3" style="color:#126db3;margin-left:-15px">{{"action_plan.summary.services" | translate}}
                </h6>
            </div>
            <div class="col-12 form-grey p-4" style="height: 300px;overflow-y: auto;overflow-x: hidden;font-size:14px;">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-4 col-md-2">
                                <span class="mr-3">{{"action_plan.summary.tarea" | translate}}</span>
                            </div>
                            <div class="col-8 col-md-10 align">
                                {{"action_plan.summary.servicios" | translate}}
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngFor="let row of servicios;index as i">
                            <div class="row hover" *ngIf="row.servicios">
                                <div class="col-4 col-md-2">
                                    <span class="ml-1">{{i+1}}</span>
                                </div>
                                <div class="col-8 col-md-10 align">
                                    <span class="ml-1">{{row.servicios}}</span>
                                </div>
                            </div>
                            <ng-container *ngIf="row.accion_hijo.length">
                                <ng-container *ngFor="let row1 of row.accion_hijo;index as j">
                                    <div class="row hover" *ngIf="row1.servicios">
                                        <div class="col-4 col-md-2">
                                            <span class="ml-1">{{i+1}}.{{j+1}}</span>
                                        </div>
                                        <div class="col-8 col-md-10 align">
                                            <span class="ml-1">{{row1.servicios}}</span>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="row1.accion_hijo.length">
                                        <ng-container *ngFor="let row2 of row1.accion_hijo;index as k">
                                            <div class="row hover" *ngIf="row2.servicios">
                                                <div class="col-4 col-md-2">
                                                    <span class="ml-1">{{i+1}}.{{j+1}}.{{k+1}}</span>
                                                </div>
                                                <div class="col-8 col-md-10 align">
                                                    <span class="ml-1">{{row2.servicios}}</span>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="row2.accion_hijo.length">
                                                <ng-container *ngFor="let row3 of row.accion_hijo;index as l">
                                                    <div class="row hover" *ngIf="row3.servicios">
                                                        <div class="col-4 col-md-2">
                                                            <span class="ml-1">{{i+1}}.{{j+1}}.{{k+1}}.{{l+1}}</span>
                                                        </div>
                                                        <div class="col-8 col-md-10 align">
                                                            <span class="ml-1">{{row3.servicios}}</span>
                                                        </div>
                                                    </div>
                                                    <ng-container *ngIf="row3.accion_hijo.length">

                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-12 col-lg-4">
            <div class="col-12">
                <h6 class="mt-3" style="color:#126db3;margin-left:-15px">{{"action_plan.summary.expenses" | translate}}
                </h6>
            </div>
            <div class="col-12 form-grey p-4" style="height: 300px;overflow-y: auto;overflow-x: hidden;font-size:14px;">
                <div class="row">
                    <div class="col-12">
                        <div class="row">
                            <div class="col-7 mr-2">
                                <span>
                                    {{"action_plan.summary.tarea" | translate}}
                                </span>
                            </div>
                            <div class="col-3 d-flex justify-content-end">
                                <span> {{"action_plan.summary.costos" | translate}}</span>
                            </div>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col-12">
                        <ng-container *ngFor="let row of costos;index as i">
                            <div class="row hover" *ngIf="row.costos!='NaN'">
                                <div class="col-7 mr-2">
                                    <span class="ml-1">{{i+1}}</span>
                                </div>
                                <div class="col-3 d-flex justify-content-end">
                                    <span class="ml-1" style="text-align: end;">{{row.costos}}</span>
                                </div>
                            </div>
                            <ng-container *ngIf="row.accion_hijo.length">
                                <ng-container *ngFor="let row1 of row.accion_hijo;index as j">
                                    <div class="row hover" *ngIf="row1.costos!='NaN'">
                                        <div class="col-7 mr-2">
                                            <span class="ml-1">{{i+1}}.{{j+1}}</span>
                                        </div>
                                        <div class="col-3 d-flex justify-content-end">
                                            <span class="ml-1" style="text-align: end;">{{row1.costos}}</span>
                                        </div>
                                    </div>
                                    <ng-container *ngIf="row1.accion_hijo.length">
                                        <ng-container *ngFor="let row2 of row1.accion_hijo;index as k">
                                            <div class="row hover" *ngIf="row2.costos!='NaN'">
                                                <div class="col-7 mr-2">
                                                    <span class="ml-1">{{i+1}}.{{j+1}}.{{k+1}}</span>
                                                </div>
                                                <div class="col-3 d-flex justify-content-end">
                                                    <span class="ml-1" style="text-align: end;">{{row2.costos}}</span>
                                                </div>
                                            </div>
                                            <ng-container *ngIf="row2.accion_hijo.length">
                                                <ng-container *ngFor="let row3 of row.accion_hijo;index as l">
                                                    <div class="row hover" *ngIf="row3.costos!='NaN'">
                                                        <div class="col-7 mr-2">
                                                            <span class="ml-1">{{i+1}}.{{j+1}}{{k+1}}.{{l+1}}</span>
                                                        </div>
                                                        <div class="col-3 d-flex justify-content-end">
                                                            <span class="ml-1" style="text-align: end;">{{row3.costos}}</span>
                                                        </div>
                                                    </div>
                                                    <ng-container *ngIf="row3.accion_hijo.length">

                                                    </ng-container>
                                                </ng-container>
                                            </ng-container>
                                        </ng-container>
                                    </ng-container>
                                </ng-container>
                            </ng-container>
                        </ng-container>
                    </div>
                    <div class="col-12 mt-3 border-top">
                        <div class="row">
                            <div class="col-7 mr-2">
                                <span>{{"action_plan.summary.total" | translate}}</span>

                            </div>
                            <div class="col-3 d-flex justify-content-end">
                                <span class="ml-1">{{total}}</span>

                            </div>
                        </div>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>